import React, { useEffect, useState } from "react";
import "./EmpProfileTile.css";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import { fonts, themes } from "../../themes/themes";

interface empType {
  avatar: any;
  title_1?: string;
  title_2?: string;
  value_color?: string;
  key_color?: string;
  is_bold?: boolean;
}
const EmpProfileTile: React.FC<empType> = ({
  avatar,
  title_1,
  title_2,
  value_color = themes.primary,
  key_color = themes.primary,
  is_bold = true,
}) => {
  return (
    <Box className="tile-containerNew">
      <Grid container spacing={2}>
        <Grid item>
          <Avatar
            src={avatar}
            style={{ width: 32, height: 32, marginRight: 5 }}
          />
        </Grid>
        <Grid item>
          <Typography className="title-1">{title_1}</Typography>
          <Typography className="title-2">{title_2}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EmpProfileTile;
